import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import SendMailButton from '../common/SendMailButton.component';
import { SendMailConf } from '../../module/handover/conf/Filter.conf';

const SendMailListAction = ({ module }) => {
    const _query = useSelector(module.query.all.selector);
    const currentFilters = useSelector(module.filter.selector);
    const userAuth = useSelector((state) => state.login?.user);

    const activeFilters = useMemo(() => _.omit(_query, ['pagination', 'sort', 'populate']), [_query]);

    const mailDefaultValues = useMemo(() => ({ ...currentFilters, emails: [{ email: '' }] }), [currentFilters]);

    const hasPermissionsSendMail = userAuth.permissions[_.toUpper(module.tag)]?.SEND_EMAIL === 'true';

    const hasMeaningfulValue = useCallback((value) => {
        if (value === null || value === undefined || value === '') return false;

        if (Array.isArray(value)) {
            return value.some(hasMeaningfulValue);
        }

        if (_.isPlainObject(value)) {
            return Object.values(value).some(hasMeaningfulValue);
        }

        return true;
    }, []);

    const hasAtLeastOneFilter = useMemo(() => hasMeaningfulValue(activeFilters), [activeFilters, hasMeaningfulValue]);

    if (!hasPermissionsSendMail) {
        return null;
    }

    return (
        <SendMailButton
            conf={SendMailConf}
            apiSettings={module.query.sendMail.settings}
            defaultValues={mailDefaultValues}
            buildPayload={(values) => ({
                emails: (values.emails || [])
                    .map((item) => item?.email?.trim())
                    .filter(Boolean),
                filters: _query?.filters,
            })}
            disabled={!hasAtLeastOneFilter}
            disabledTooltip="Select at least one filter to send the email"
            tooltipTitle="Send Mail"
            successMessage="Success: Email sent!"
        />
    );
};

export default SendMailListAction;